export default {
    name: 'EditPwd',
    props: {},
    data() {
        return {
            isShow: false,
            isLoading: false,
            form: {
                oldPassword: '',	//	旧密码
                newPassword: '',	//	新密码
                newPasswordS: '',	//	确认新密码
                accountName: '',	//	账号
            },
            rules2: {
                oldPassword: [{ required: true, trigger: 'blur', message: '请输入旧密码' }],
                newPassword: [{
                    validator: (rule, value, callback) => {
                        const re = /^(?=.*[a-zA-Z])(?=.*\d)[^]{6,16}$/;
                        if (!re.test(this.form.newPassword)) {
                            callback(new Error('长度必须6-16位，且由字母和数字组成'));
                        } else {
                            callback();
                        }

                    }, trigger: 'blur'
                }],
                newPasswordS: [{
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请再次输入密码'));
                        } else if (value !== this.form.newPassword) {
                            callback(new Error('两次输入密码不一致!'));
                        } else {
                            callback();
                        }
                    }, trigger: 'blur'
                }],
            },
            title: '',
            mask: false,
            callback: () => { },
        };
    },
    methods: {
        // 用于初始化一些数据
        init() { },
        // 用于更新一些数据
        update() { },
        async show(mask = false, title = '修改密码', callback = () => { }) {
            this.isShow = true;
            this.mask = mask;
            this.title = title;
            this.callback = callback;
            this.$UserInfo = JSON.parse(localStorage.UserInfo);
            this.form.accountName = this.$UserInfo.A_UserName;//当前用户ID
            this.form.opUserId = this.$UserInfo.U_UserId;//当前用户ID

        },
        async submit() {
            this.$refs['form'].validate(async (valid) => {
                if (valid) {
                    const res = await this.$http.post('Kindergarten/ChangePassword_Back', this.form);
                    if (res.Status) {
                        // this.callback(res);
                        // this.$success(res.Msg);
                        localStorage.removeItem('noPwd');
                        this.isShow = false;
                        localStorage.clear();
                        sessionStorage.clear();
                        setTimeout(() => {
                            window.location.reload()
                        }, 300);
                    } else {
                        this.$error(res.Msg);
                    }
                } else {
                    return false;
                }
            });
        },
    },
    // 计算属性
    computed: {
        pwdStrength() {
            const re = /^(?=.*[a-zA-Z])(?=.*\d)[^]{6,16}$/;
            return re.test(this.form.newPassword);
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() { },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => { });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        '$route': {
            immediate: true,
            deep: true,
            handler() {
                if (typeof localStorage['noPwd'] != 'undefined') {
                    this.show();
                }
            }
        }
    },
    // 组件列表
    components: {},
};